export const testData = [
  {
    // 一条议程里，一条议题，一个人,那总共就1条数据
    id:1,
    title: '第1个议程',
    feedbackList: [
      {
        id: 10000001,
        conferenceId: 101,
        declarationId: 2000001,
        title: '议题标题 2000001',
        summary: '会议纪要 2000001',
        feedback: '会议反馈 2000001',
        reportUserId: 9,
        reportUserName: '我自己'
      }
    ]
  },
  {
    //一条议程里，一条议题，多个人
    id:2,
    title: '第2个议程',
    feedbackList: [
      {
        id: 10000002,
        conferenceId: 101,
        declarationId: 2000002,
        title: '议题标题 2000002',
        summary: '会议纪要 2000002',
        feedback: '会议反馈 2000002 5002',
        reportUserId: 5002,
        reportUserName: '汇报人名称 5002'
      },
      {
        id: 10000003,
        conferenceId: 101,
        declarationId: 2000002,
        title: '议题标题 2000002',
        summary: '会议纪要 2000002',
        feedback: '会议反馈 2000002 5003',
        reportUserId: 5003,
        reportUserName: '汇报人名称 5003'
      }
    ]
  },
  {
    //  一条议程里，多条议题，每条单个人
    id:3,
    title: '第3个议程',
    feedbackList: [
      {
        id: 10000004,
        conferenceId: 101,
        declarationId: 2000003,
        title: '议题标题 2000003',
        summary: '会议纪要 2000003',
        feedback: '会议反馈 2000003 6002',
        reportUserId: 6002,
        reportUserName: '汇报人名称 6002'
      },
      {
        id: 10000005,
        conferenceId: 101,
        declarationId: 2000004,
        title: '议题标题 2000004',
        summary: '会议纪要 2000004',
        feedback: '会议反馈 2000004 6003',
        reportUserId: 6003,
        reportUserName: '汇报人名称 6003'
      },
    ]
  },
  {
    //  一条议题里，多条议题，每条多个人
    id:4,
    title: '第4个议程',
    feedbackList: [
      {
        id: 10000006,
        conferenceId: 101,
        declarationId: 3000003,
        title: '议题标题 3000003',
        summary: '会议纪要 3000003',
        feedback: '会议反馈 3000003 7002',
        reportUserId: 7002,
        reportUserName: '汇报人名称 7002'
      },
      {
        id: 10000007,
        conferenceId: 101,
        declarationId: 3000003,
        title: '议题标题 3000003',
        summary: '会议纪要 3000003',
        feedback: '会议反馈 3000003 7003',
        reportUserId: 7003,
        reportUserName: '汇报人名称 7003'
      },
      //---------
      {
        id: 10000008,
        conferenceId: 101,
        declarationId: 4000003,
        title: '议题标题 4000003',
        summary: '会议纪要 4000003',
        feedback: '会议反馈 4000003 8002',
        reportUserId: 8002,
        reportUserName: '汇报人名称 8002'
      },
      {
        id: 10000009,
        conferenceId: 101,
        declarationId: 4000003,
        title: '议题标题 4000003',
        summary: '会议纪要 4000003',
        feedback: '会议反馈 4000003 8003',
        reportUserId: 8003,
        reportUserName: '汇报人名称 8003'
      },
    ]
  },
]